import UtilityHelper from "../utilities/UtilityHelper";
import { MetaDataModel } from "../../model/service/MetaDataModel";

export type MetadataType = {
  title?: string;
  description?: string;
  image?: string;
  url?: string;
};

export const fetchMetadata = async (
  url: string
): Promise<MetadataType | null> => {
  // https://api.allorigins.win/get?url=
  // https://corsproxy.org/?${encodeURIComponent(url)}
  // https://thingproxy.freeboard.io/fetch/
  // https://jsonlink.io/api/extract?url=
  // `https://jsonlink.io/api/extract?api_key=pk_9c6a2637f5b07f62809d14dfc3a9f25b6393b615&url=${encodeURIComponent( url  )
  // https://api.allorigins.win/raw?url=
  // https://api.allorigins.win/raw?url=https://api.publicapis.org/entries
  // https://corsproxy.io/?https://api.publicapis.org/entries

  if (UtilityHelper.isNotEmpty(url) && UtilityHelper.isValidURL(url)) {
    try {
      const resp = await fetch(
        `https://api.microlink.io?url=${encodeURIComponent(url)}`
      );
      if (!resp.ok) throw new Error("Metadata fetch failed");
      const metaDataModel: MetaDataModel | null = await resp.json();

      if (metaDataModel != null && metaDataModel.statusCode === 200) {
        const data: MetadataType = {
          title: metaDataModel?.data?.title!,
          description: metaDataModel?.data?.description!,
          image: metaDataModel?.data?.image?.url!,
          url: metaDataModel?.data?.url!,
        };

        return data;
      }
      return null;
    } catch (err: any) {
      console.log(err.message);
      return null;
    }
  }

  return null;
};
